import { render, staticRenderFns } from "./TreatmentCreatePPS.vue?vue&type=template&id=28f43df3&scoped=true&"
import script from "./TreatmentCreatePPS.vue?vue&type=script&lang=js&"
export * from "./TreatmentCreatePPS.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentCreatePPS.vue?vue&type=style&index=0&id=28f43df3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f43df3",
  null
  
)

export default component.exports